<script>
  import { fade } from "svelte/transition";
  import Title from "../components/Title.svelte";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Placeholder from "../components/placeholder/Placeholder.svelte";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert;
  $: alert = []; 
  let itemsDisplay = false;
  let items = [];

  let uid = Math.random().toString(36).substring(2);
  axios
    .get(settings.url + "/sipade/akun", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      items = response.data;
      itemsDisplay = true;
    })
    .catch(function (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("t");
        redirect("/login");
      } else {
        if (error.response.data.message) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      }
    });

  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }

  let require;
  $: require = {
    utelp: "",
    pass: "",
  };

  let number;
  $: number = {
    utelp: require.utelp,
  };
  //#FORM Data Payload

  let errorForm;
  $: errorForm = errorForm;
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
        
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?([0-9]\d*)$/.test(number[n])) {
        
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    
    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  function handleSubmit() {
    let valid = validator();
    if (valid) {
      axios
        .post(settings.url + "/sipade/kontak?authorization=" + settings.token, {
          utelp: require.utelp,
          utelppass: require.pass,
        })
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: response.data.message,
              color: "green",
            },
          ];

          setTimeout(() => {
            redirect("/akun");
          }, 3000);
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            localStorage.removeItem("t");
            
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda mungkin harus login kembali",
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          }
        });
    } else {
      
      alert = [
        {
          title: "Dekatan",
          message: "Ada kolom yang belum Terisi dengan benar",
          color: "orange",
        },
      ]; 
    }
  }

  $: lengthCount = require.utelp.length;
</script>
<svelte:head>
<title>Kelola Nomor Ponsel - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation['message']}
  title="Profil Anda" />
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  <div class="pt-2 mx-auto my-5 lg:mt-10 lg:my-0">
    {#if itemsDisplay == false}
      <div class="max-w-lg mx-auto rounded-lg">
        <div class="w-full mx-auto my-5 lg:my-0">
          <div class="w-full mx-auto mb-2">
            <div class="p-10 bg-white rounded-md shadow-md">
              {#each [1] as l}
                <Placeholder type="6" />
              {/each}
            </div>
          </div>
        </div>
      </div>
    {:else}
      <div class="max-w-lg mx-auto rounded-lg">
        <div class="w-full mx-auto my-5 lg:my-0">
          
          <div class="w-full mx-auto mb-2">
            <div class="p-10 pt-5 bg-white rounded-md shadow-md">
    <Title subtitle="Perbaharui Nomor Ponsel" tipe=2 title="Nomor Ponsel" />
              <form class="w-full" on:submit|preventDefault={handleSubmit}>
                <div id="stepcontID1" class="block stepcontID">
                  {#if errorForm}
                    {#if errorForm.length > 0}
                    <div
                      class="w-full p-2 mt-4 mb-5 text-sm italic text-red-500 border border-l-4 border-red-500 rounded-lg">
                      Mohon isi dengan benar,
                      <br />
                      {#each errorForm as e}
                        - Kolom
                        <b>{document.getElementById(e.field + '-labelwarning').innerText}</b>
                        {e.message}<br />
                      {/each}
                    </div>
                  {/if}
                  {/if}
                  {#if items.pen.hp == '0'}
                    <div class="w-full lg:w-auto">
                      <div
                        class="w-full p-2 mx-auto mb-2 text-xs bg-blue-300 border-4 border-t border-b border-r border-blue-600 border-solid rounded shadow-lg lg:w-auto color-white">
                        <h2 class="text-sm font-bold">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="inline-block w-5 h-5">
                            <path
                              d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0
                      1 16 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z" />
                          </svg>
                          Perhatian
                        </h2>
                        <p>
                          Pastikan nomor yang diinput aktif dan terhubung dengan
                          akun WhatsApp
                        </p>
                      </div>
                    </div>
                  {:else}
                    Nomor saat ini :<br />
                    <span
                      class="font-mono text-xl font-bold">{items.pen.hp}</span>
                  {/if}

                  <section class="mt-10">
                    <label
                      for="utelp"
                      class="relative block text-sm font-light">
                      <input
                        autocomplete="off"
                        minlength="10"
                        id="utelp"
                        type="text"
                        name="utelp"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="628**********"
                        bind:value={require.utelp} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                        id="utelp-labelwarning">No. HP/WA <span class="text-xs">(tanpa awalan + atau 0)</span></span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="utelp-warning" />
                    </label>
                  </section>
                  <p class="mt-5 text-sm text-center">
                    Konfirmasi kata sandi untuk memastikan ini adalah kamu
                  </p>

                  <section class="mt-5">
                    <label
                      for="utelp"
                      class="relative block text-sm font-light">
                      <input
                        autocomplete="off"
                        type="password"
                        id="pass"
                        name="pass"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="Kata sandi..."
                        bind:value={require.pass} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                        id="pass-labelwarning">Password</span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass-warning" />
                    </label>
                  </section>

                  <button
                    type="button"
                    class="w-auto px-10 py-2 my-5 text-gray-100 bg-green-600 rounded text-1xl focus:bg-gray-500 focus:outline-none"
                    on:click={loadingBtn}
                    on:click={handleSubmit}>
                    SIMPAN
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
</main>
